module.exports = __webpack_public_path__ + "github-2-87cbb41dd02f3883d38b7ec3089b1384.webp";